import React from "react";
import Typed from "react-typed";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-wrapper" id='home'>
      <div className="main-info">
        <h1>I'm Minhazur Rahman Rafi <br/>a <span>
        <Typed
        className="typed-text"
          strings={[
            "MERN Stack Developer",
            "Programmer",
          ]}
          typeSpeed={40}
          backSpeed={50}
          loop
        /></span></h1>
        
        <a className='btn-main-offer' href="https://drive.google.com/u/0/uc?id=1Ly8uzXtwntjXPCOmSRKnt4isHpe8JH-S&export=download" download>My Resume</a>
      </div>
    </div>
  );
};

export default Header;
